// app_C_CHART_Node_DepthAboveInvert.tsx
import "./index.css"
import { UIBackground, SiteNavBar } from "./swmmreact"
import { C_CHART_Node_DepthAboveInvert } from "./swmmReact_controls"
import SyntaxHighlighter from 'react-syntax-highlighter'
import { nightOwl as codeStyle } from 'react-syntax-highlighter/dist/esm/styles/hljs'
/* eslint import/no-webpack-loader-syntax: off */
const useDidMount = require('!!raw-loader!./C_CHART_Node_DepthAboveInvert.tsx')

const App = () => {
  return(
    <div >
      <SiteNavBar />
      <div >
        <div style={UIBackground}><h1>Charting: Node Depth Above Invert</h1>
          <p>This demo shows how to utilize swmmReact controls and components to create an interactive app for displaying swmm model 
            <b> node depth above invert</b>. 
            For an in-depth explanation of the components of this web app, see the entries for any item in the list below:</p>
          <ul>
            <li>OpenDefaultOutFileHeadless</li>
            <li>OUTDirectoryParser</li>
            <li>OUTDataType_Headless</li>
            <li>OUTObjectType_Headless</li>
            <li>OUTSeriesTransformer</li>
            <li>OUTLineChartTime_Recharts</li>
            <li>OUTNodesMultiSelect</li>
          </ul>
          <p><b>Node depth above invert </b> 
          is related to the model unit types (SI or US). The controls involved in this app are customized for any of the possible selections. The resulting chart is responsive, and can be placed nearly anywhere in your webpage.</p>
            <C_CHART_Node_DepthAboveInvert />

            <h2>Example swmmReact code</h2>
            <p>The following code window shows one way to display this info using swmmReact.</p>
            <SyntaxHighlighter language='typescript' style={codeStyle} showLineNumbers={true}>
              {useDidMount.default.toString()}
            </SyntaxHighlighter>
          </div>
        </div>
    </div>
  )
}

export default App;